import { call, put } from 'redux-saga/effects';
import {
    requestGetKBTags,
    requestGetKBArticles,
    requestGetKBArticle,
    requestCreateKBArticle,
    requestCreateKBArticleFromProject,
    requestKBAIRewrite,
    requestUpdateKBArticle,
    requestDeleteKBArticle,
    requestGetKBArticleVersions,
} from '../requests/kb';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetKBTags(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestGetKBTags);
        if (callback) callback(response.data);
    } catch (error) {
        if (callback) callback([]);
    }
}

export function* handleGetKBArticles(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestGetKBArticles, action.payload.params);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleGetKBArticle(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestGetKBArticle, action.payload.id);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleCreateKBArticle(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestCreateKBArticle, action.payload.data);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleCreateKBArticleFromProject(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestCreateKBArticleFromProject, action.payload.projectId, action.payload.data);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleRequestKBAIRewrite(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestKBAIRewrite, action.payload.projectId, action.payload.data);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleUpdateKBArticle(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestUpdateKBArticle, action.payload.id, action.payload.data);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleDeleteKBArticle(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestDeleteKBArticle, action.payload.id);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleGetKBArticleVersions(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestGetKBArticleVersions, action.payload.id);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}
